import { Theme } from '@mui/material';
import { PRIMARY_PAYMENT_DARK, PRIMARY_REWARDS_LIGHT, WHITE } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

const CONTAINER_WIDTH = 600;

export const styles = makeStyles()((theme: Theme) => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: theme.spacing(5)
    },
    header: {
      width: CONTAINER_WIDTH
    },
    bodyContainer: {
      backgroundColor: PRIMARY_REWARDS_LIGHT,
      padding: theme.spacing(5, 4.5, 7),
      width: CONTAINER_WIDTH,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    body: {
      borderRadius: 8,
      backgroundColor: WHITE,
      padding: theme.spacing(3, 2),
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    text: {
      marginBottom: theme.spacing(3)
    },
    button: {
      backgroundColor: PRIMARY_PAYMENT_DARK
    },
    errorTitle: {
      marginBottom: theme.spacing(1)
    },
    errorSubtitle: {
      marginBottom: theme.spacing(3)
    }
  };
});
